"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientsImportPreview = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/patients/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const button_1 = require("../../../../components/material/button");
require("./patients-import-preview.less");
const core_1 = require("@material-ui/core");
const us_states_1 = require("../../../../modules/constant/us-states"); //B-038
/**
 * Render a preview representing the mapped header columns from the imported spreadsheet to be persisted to the database;
 */
let PatientsImportPreview = class PatientsImportPreview extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.listOfState = us_states_1.GLOBAL_PROVINVCE; //B-038
        this.handleOnConfirmation = () => {
            this.showConfirmationModal = true;
        };
        this.handleSubmitReview = async () => {
            this.showConfirmationModal = false;
            this.loadingSaving = true;
            const nameRe = /["\(][\w\s]+[\)"]/g;
            const { sitesIds } = store_1.patientsStore.importedFileAndSitesIds;
            this.patientsToPersist.map((patient) => {
                patient.notes = "";
                patient.firstName = patient.firstName.replace(nameRe, "");
                patient.lastName = patient.lastName.replace(nameRe, "");
                patient.birthDate = patient.birthDate
                    ? moment(patient.birthDate).format("YYYY-MM-DD")
                    : null;
                // B.038.3 2024-04-23 16:10:36
                patient.gender = patient.gender
                    ? patient.gender.trim().toLowerCase()[0] === "m" ||
                        patient.gender.trim().toLowerCase() === "MALE" ||
                        patient.gender.trim().toLowerCase() === "Male" ||
                        patient.gender.trim().toLowerCase() === "man" ||
                        patient.gender.trim().toLowerCase() === "Man" ||
                        patient.gender.trim().toLowerCase() === "M"
                        ? "1"
                        : patient.gender.trim().toLowerCase()[0] === "f" ||
                            patient.gender.trim().toLowerCase() === "female" ||
                            patient.gender.trim().toLowerCase() === "FEMALE" ||
                            patient.gender.trim().toLowerCase() === "Female" ||
                            patient.gender.trim().toLowerCase() === "Woman" ||
                            patient.gender.trim().toLowerCase() === "woman"
                            ? "2"
                            : ""
                    : "";
                // patient.gender = patient.gender
                //   ? patient.gender.trim().toLowerCase()[0] === "m"
                //     ? "1"
                //     : patient.gender.trim().toLowerCase()[0] === "f"
                //     ? "2"
                //     : ""
                //   : "";
            });
            store_1.patientsStore.submitPatientsImportToManySites(this.patientsToPersist, sitesIds);
        };
        this.handleOnCancel = () => {
            // console.log('handleOnCancel triggered');
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
        this.renderPreview = () => {
            const patientRowsArray = this.patientsToPersist.map((patient) => {
                const data = [];
                for (const prop in patient) {
                    if (patient.hasOwnProperty(prop)) {
                        data.push(patient[prop]);
                    }
                }
                return data;
            });
            // prepend header
            const headers = [];
            for (const prop in this.patientsToPersist[0]) {
                if (this.patientsToPersist[0].hasOwnProperty(prop)) {
                    headers.push(prop);
                }
            }
            patientRowsArray.unshift(headers);
            return patientRowsArray.map((row, i) => this.renderTableRow(row, i));
        };
    }
    /**
     * Parse the patientsToPersist based on the user mapped header columns that should reflect the preview rendered.
     */
    async componentWillMount() {
        const mappedHeadersObject = store_1.patientsStore.mappedHeadersObject || {};
        store_1.patientsStore.importedPatients.map((item) => {
            if (item.State) {
                item.State = item.State.toLowerCase();
                if (this.listOfState[item.State]) {
                    item.State = this.listOfState[item.State];
                }
                else {
                    item.State = item.State;
                }
            }
            return;
        });
        const importedPatients = store_1.patientsStore.importedPatients;
        const nameRe = /["\(][\w\s]+[\)"]/gm;
        this.patientsToPersist = importedPatients.map((patient, index) => {
            const newPatient = {};
            for (const key in mappedHeadersObject) {
                if (mappedHeadersObject.hasOwnProperty(key)) {
                    if (key === "firstName" || key === "lastName") {
                        patient[mappedHeadersObject[key]] = patient[mappedHeadersObject[key]].replace(nameRe, "");
                    }
                    newPatient[key] = patient[mappedHeadersObject[key]];
                    // newPatient[this.databaseColumnsHeaderNewBindRevers[key]] = newPatient[key]; // C-001 
                    // delete newPatient[key]  // C-001 
                }
            }
            return newPatient;
        });
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement("div", { className: "header-paper--select" },
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please review the data"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { onClick: this.handleOnCancel, to: "/patients/import/map" }, "Back"),
                            React.createElement(button_1.MaterialButton, { disabled: this.loadingSaving, primary: true, onClick: this.handleOnConfirmation }, "confirm"))),
                    this.patientsToPersist && (React.createElement(core_1.Table, { className: "select-header-table" },
                        React.createElement(core_1.TableBody, null, this.patientsToPersist && this.renderPreview()))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container--select__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container--select__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Submit", cancelText: "Back to review", message: `Please review the mapped table. If you are satisfied with the mapping, please submit.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: this.handleSubmitReview, title: "Review confirmation" }))));
    }
};
__decorate([
    mobx_1.observable
], PatientsImportPreview.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], PatientsImportPreview.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], PatientsImportPreview.prototype, "patientsToPersist", void 0);
__decorate([
    mobx_1.observable
], PatientsImportPreview.prototype, "listOfState", void 0);
PatientsImportPreview = __decorate([
    mobx_react_1.observer
], PatientsImportPreview);
exports.PatientsImportPreview = PatientsImportPreview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-import-preview/patients-import-preview.tsx
// module id = 3818
// module chunks = 0